import React from "react";
import { Box, Typography, Button } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import CustomTextField from "../../CustomTextField";

const DecorationCharges = ({ charges = [], isEditMode, onChargesUpdate, decorationInfo }) => {
    const handleChargeNameChange = (index, value) => {
        const updatedCharges = [...charges];
        updatedCharges[index].name = value;
        onChargesUpdate(updatedCharges);
    };

    const handleChargePriceChange = (index, value) => {
        const updatedCharges = [...charges];
        updatedCharges[index].price = value;
        onChargesUpdate(updatedCharges);
    };

    const handleDeleteCharge = (index) => {
        const updatedCharges = charges.filter((_, i) => i !== index);
        onChargesUpdate(updatedCharges);
    };

    const handleAddCharge = () => {
        const updatedCharges = [...charges, { name: '', price: '' }];
        onChargesUpdate(updatedCharges);
    };

    return (
        <Box mt={3}>
            {charges?.length > 0 || isEditMode && <Typography variant="subtitle1" fontWeight="bold" mb={1}>Charges</Typography>}
            {charges?.map((charge, index) => (
                <Box key={index} display="flex" alignItems="center"
                    // gap={2} mb={1}
                    sx={{
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom:'15px',
                        '&:hover .delete-icon': {
                            opacity: 1,
                            visibility: 'visible',
                        },
                    }}>
                    <Button
                        className="delete-icon"
                        variant="text"
                        color="error"
                        size="small"
                        sx={{
                            minWidth: '30px',
                            opacity: 0,
                            visibility: 'hidden',
                            transition: 'opacity 0.3s ease',
                        }}
                        onClick={() => handleDeleteCharge(index)}
                    >
                        {isEditMode && <CloseIcon fontSize="small" />}
                    </Button>

                    <Box sx={{ borderBottom: isEditMode ? '1px solid #ccc' : '', width: isEditMode ? '180px' : '', minWidth: '300px',
                        color: !isEditMode ? '#179ea5' : '',

                     }}>
                        {isEditMode ? <CustomTextField
                            disabled={!isEditMode}
                            name={`chargeName-${index}`}
                            placeholder="Charge Name"
                            value={charge.name}
                            handleChange={(e) => handleChargeNameChange(index, e.target.value)}
                        /> :

                            charge.name
                        }
                    </Box>
                    <Box sx={{ borderBottom: isEditMode ? '1px solid #ccc' : '', width: isEditMode ? '180px' : '180px', marginLeft: '20px' }}>
                        {isEditMode ? <CustomTextField
                            disabled={!isEditMode}
                            name={`chargePrice-${index}`}
                            placeholder="Price"
                            value={charge.price}
                            type="number"
                            handleChange={(e) => handleChargePriceChange(index, e.target.value)}
                        /> :
                            // <Typography sx={{
                            //     width:'180px !important'
                            // }}
                            // >
                            charge.price
                            // {/* </Typography> */}
                        }
                    </Box>
                    <Typography sx={{ marginLeft: '20px', width: '180px' }}>{decorationInfo?.type === 'List' ? decorationInfo?.increment || decorationInfo?.increment !== 1 ? `Per ${decorationInfo?.increment} ${decorationInfo?.units}` : `Per ${decorationInfo?.units}` : decorationInfo?.type === 'Per Item' ? `Per Item` : ''}</Typography>
                </Box>
            ))}

            {isEditMode && <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={handleAddCharge}
            >
                Add Charge
            </Button>}
        </Box>
    );
};

export default DecorationCharges;
